var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 18.1334C3.36813 18.2723 5.43896 17.6956 7.45853 16.1684C5.41845 15.8053 4.00373 14.8334 3.23486 12.8257C3.82946 12.7402 4.35229 12.9004 4.96739 12.6441C2.95807 11.7257 1.65611 10.348 1.60485 7.96648C2.24045 8.01988 2.72228 8.45774 3.4809 8.39366C1.63561 6.51406 1.07176 4.46359 2.2302 1.97525C4.1575 4.28203 6.41287 5.85193 9.17056 6.58882C9.32433 6.63154 9.46785 6.67425 9.62162 6.70629C10.329 6.87717 11.1696 7.24027 11.6002 7.18687C12.3383 7.09076 11.6002 6.20435 11.7847 5.05096C12.3691 1.46263 16.1622 -0.171341 18.9711 1.93253C19.7912 2.55195 20.4371 2.54127 21.247 2.16748C21.6673 1.97525 22.0979 1.78302 22.6002 1.55875C22.4874 2.58398 21.7288 3.15 21.124 3.90825C21.8108 4.06844 22.3644 3.86553 23 3.65194C22.7847 4.38883 22.2516 4.80533 21.7698 5.21116C21.2675 5.62766 21.0727 6.06552 21.0522 6.74901C20.7446 17.0975 9.4576 25.0965 1.73813 18.7315C0.989756 18.1121 1.71761 18.7315 1 18.1334Z",
    stroke: "#0C7D84",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.1e0abd2258e692f095327e2e8091f1f7.svg";
export { ForwardRef as ReactComponent };